import { render, staticRenderFns } from "./SpecialQuestions.vue?vue&type=template&id=bc6e54da&scoped=true"
import script from "./SpecialQuestions.vue?vue&type=script&lang=js"
export * from "./SpecialQuestions.vue?vue&type=script&lang=js"
import style0 from "./SpecialQuestions.vue?vue&type=style&index=0&id=bc6e54da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6e54da",
  null
  
)

export default component.exports